/**
 * Counting things, in a language that does not count like English.
 *
 * English has two forms and Polish has three: 1 zdjęcie, 2 zdjęcia, 5 zdjęć —
 * and the third is chosen by the last digits, so 22 goes back to "zdjęcia" and
 * 25 does not. `count === 1 ? one : other` is right in English and wrong in
 * Polish for most numbers a photo library ever shows.
 *
 * `Intl.PluralRules` knows the rule for every language the browser has, so the
 * only thing left is supplying the words.
 */

export type PluralForms = Partial<Record<Intl.LDMLPluralRule, string>>;

export function plural(
  locale: string,
  count: number,
  forms: PluralForms,
): string {
  const rule = new Intl.PluralRules(locale).select(count);
  // `other` is the form every language defines, so it is the safe fallback for
  // a category this particular set of words does not spell out.
  return forms[rule] ?? forms.other ?? "";
}
